---
label: Command Palette
category: core
icon: PaletteIcon
keywords: [command palette, search, find, navigate, quick open]
addedInVersion: "0.0.0"
---

# Command Palette

The command palette is the fastest way to navigate, search, and run commands.

## Opening

Press <KbdGroup><Mod /> + <Kbd>K</Kbd></KbdGroup> to open the palette.

## What You Can Do

- **Open files** — find sequences, alignments, collections, and folders by name.
- **Create sequences** — start a new sequence from scratch, from FASTA, or by
  GenBank accession.
- **Browse references** — jump to the primers library or restriction enzymes.
- **Open settings** — go directly to any settings page.
- **Search** — type to filter across all files, commands, primers, enzymes, and
  features.

